module.exports = __webpack_public_path__ + "static/media/globe.f8878095.svg";